import React, { useState, useEffect, useMemo, useRef } from 'react'
import ReactDOM from 'react-dom'
import Button from 'meinian-package/src/baseComponent/button'
import qs from 'qs'
import { request } from 'meinian-package/src/utils'
import util from 'meinian-package/src/utils/util'
import { isPermissions } from 'meinian-package/src/utils/auth'
import Checkbox from 'meinian-package/src/baseComponent/checkbox'
import Modal from 'meinian-package/src/component/modal'
import ExpandSelect from '../../expandSelect'
import { FolderTreeSample } from '../../folderTree'
import styles from './index.module.less'

const SampleModal = ({ visible = false, onClose, authList = [], trackSourceType, onOk }) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [processValue, setProcessValue] = useState(null)
  const _folderId = location.pathname.startsWith('/meinian/home/sample') ? +query.childId || +query.parentId || -1 : -1
  const [folderVal, setFolderVal] = useState(_folderId)
  const [options, setOptions] = useState([])
  const clickStatus = useRef(true)
  const [authFolder, setAuthFolder] = useState(true)

  useEffect(() => {
    fetchData()
    fetchAuthData()
  }, [])

  const fetchData = async () => {
    const result = await request.get('/zhikuan/ins/inspiration/work/platform/get-sample-process', { params: { sortField: 'lastChooseTime' } })
    const _result = result.map(item => ({ label: item.processName, value: item.id, ...item }))
    setProcessValue(_result?.[0]?.value)
    setOptions(_result || [])
  }

  const fetchAuthData = async () => {
    const result = await request.get('/zhikuan/mn/sample/auth/get-user-folder-auth')
    setAuthFolder(result.some(i => i === 'createAndUpdateFolder'))
  }

  const _onOk = async () => {
    if (clickStatus.current) { // 防止重复点击
      clickStatus.current = false
      const flag = await onOk?.(processValue, {
        sampleFolderId: folderVal,
      })
      clickStatus.current = true
      if (!trackSourceType) {
        util.track('mn-add-sample', {
          module1: '设为样衣',
        })
      }
      if (flag === false) {
        return
      }
      set_Visible(false)
    }
  }

  const option = useMemo(() => {
    return options.find(item => item.id === processValue)?.steps
  }, [processValue, options])

  const [_visible, set_Visible] = useState(visible)

  useEffect(() => {
    set_Visible(visible)
  }, [visible])

  const _onClose = () => {
    set_Visible(false)
    onClose?.()
  }

  const _auth = authList.length ? isPermissions(authList, ['FS13', 'FCS14']) : true

  return <Modal
    visible={_visible}
    style={{ width: '480px', minHeight: 'unset', maxHeight: 'calc(100vh - 48px)', overflow: 'auto', }}
    hiddenFooter
    title="样衣设置"
    onClose={_onClose}
  >
    <div className={styles['mn-sample-modal']}>
      {
        !!options.length && _auth && <div className="mn-sample-modal-title">
          <div className="mn-sample-modal-title-content">选择新建样衣执行的流程</div>
        </div>
      }
      <div className="mn-sample-modal-content">
        {
          !!options.length && _auth && <>
            <ExpandSelect value={processValue} option={options} onChange={(curData, val) => setProcessValue(val)} wrapperStyle={{ marginTop: '8px' }} />
            {
            processValue && <div className="mn-sample-modal-content-content">
              <div className="mn-sample-modal-content-content-right">
                {
                option?.map((item) => <div className="mn-sample-modal-content-content-right-item" key={item.id}>
                  <div className="mn-sample-modal-content-content-point" />
                  <div className="mn-sample-modal-content-content-right-item-label">
                    <div className="mn-sample-modal-content-content-right-item-label-index">{item.sortValue}</div>{item.stepName}
                  </div>
                </div>)
              }
              </div>
              <div className="mn-sample-modal-content-content-line" />
            </div>
          }
            <div className="mn-sample-modal-content-divider" />
          </>
        }
        <div className="mn-sample-modal-content-folder">
          <div className="df-center-space-between">
            <div className="mn-sample-modal-content-folder-header-title">选择样衣文件夹</div>
            <div className="df-center-center mn-sample-modal-content-folder-header-right">
              <Checkbox
                checked={folderVal === -1}
                onChange={() => {
                  setFolderVal(-1)
                }}
              />
              <span className="ml4">不加入</span>
            </div>
          </div>
          <div className="mn-sample-modal-content-folder-tree">
            <FolderTreeSample
              value={folderVal}
              hiddenRoot={false}
              createFolderAuth={authFolder}
              contentHeight={200}
              onCreateComplete={(curData, _parentId, resultData) => {
                setFolderVal(resultData.id)
              }}
              onChange={(curData, val) => setFolderVal(val)}
            />
          </div>
        </div>
      </div>
      <div className="mn-sample-modal-footer">
        <Button type="normal" onClick={_onClose} style={{ marginRight: 8, width: 88 }}>取消</Button>
        <Button type="primary" style={{ width: 88 }} onClick={_onOk}>确定</Button>
      </div>
    </div>
  </Modal>
}

SampleModal.show = (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    ReactDOM.render(<SampleModal {...props} visible container={div} />, div)
  })
}

export default SampleModal
